import React from 'react';
import { useFormikContext, getIn } from 'formik';
import { useParams } from 'react-router-dom';

import * as api from 'api/methods';

import GeneralSection from './GeneralSection';

const GeneralSectionContainer = ({ namePrefix, ...restProps }) => {
  const { lessonId } = useParams();

  const { values, setFieldValue } = useFormikContext();

  const handleTranslateClick = async () => {
    try {
      const task = getIn(values, namePrefix);

      const taskIndex = values.tasks.findIndex((t) => t.id === task.id);

      const lesson = await api.translateTask(lessonId, {
        taskIndex,
        text: task.text,
      });

      setFieldValue(`${namePrefix}.text`, lesson.tasks[taskIndex].text);
    } catch (error) {
      console.warn(error);
    }
  };

  return (
    <GeneralSection
      {...restProps}
      namePrefix={namePrefix}
      onTranslateClick={handleTranslateClick}
    />
  );
};

export default GeneralSectionContainer;
